<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div>

		<!-- PROGRESS STEPS -->
		<section class="section-steps">
			 <ProgressSteps :steps="stagesArray.length" :step="stage" :stagechanges="stagesArray"></ProgressSteps>
		</section>

		<div class="container">
			<div class="add-page">

				<!-- STAGE 1 -->
				<section class="section-typeAndStatus" v-if="stage == stages.EVENT">
					<h2 class="margin-top-0">Add BestAgent Trigger</h2>

					<p>Choose BestAgent Event you want to be notified of:</p>

					<select class="mdc-select" v-model="eventType">
						<option value="">-- Select event type --</option>
						<option v-for="eventType in eventTypes" :value="eventType">{{eventType}}</option>
					</select><br>

					<select class="mdc-select" v-model="eventValue">
						<option value="">-- Select event --</option>
						<option v-for="event in eventsFromType" :value="event.name">{{event.name}}</option>
					</select>

					<div class="mdc-layout-grid">
						<button class="mdc-button mdc-button--raised" v-on:click="stage = stages.ENDPOINT">Next</button>
					</div>
				</section>

				<!-- STAGE 2 -->
				<section class="section-typeAndStatus" v-if="stage == stages.ENDPOINT">
					<h2 class="margin-top-0">Your API Endpoint</h2>

					<p>Enter your API endpoint to send our data and the HTTP method:</p>
					<select class="mdc-select">
						<option value="">-- HTTP Method --</option>
						<option value="GET">GET</option>
						<option value="POST">POST</option>
						<option value="PUT">PUT</option>
						<option value="DELETE">DELETE</option>
					</select>
					<input class="mdc-textfield__input" type="text" placeholder="e.g. https://api.yourcompany.co.uk/v1/something">

					<div class="mdc-layout-grid">
						<button class="mdc-button mdc-button--raised" v-on:click="stage = stages.PAYLOAD">Next</button>
						<a class="back-button black-link" @click="stage = stages.EVENT">&lt; back</a>
					</div>
				</section>

				<!-- STAGE 3 -->
				<section class="section-typeAndStatus" v-if="stage == stages.PAYLOAD">
					<h2 class="margin-top-0">Your API Payload</h2>

					<p>Enter the API payload you need to send to your API. Use BestAgent placeholders.</p>

					<div class="mdc-layout-grid">
						<div class="mdc-layout-grid__inner">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2" style="position: relative;">
								Placeholders:
								<div>[SERVICE_TYPE]</div>
								<div>[PROPERTY_ID]</div>
								<div>[TYPE]</div>
								<div>[STATUS]</div>
								<div>[DATE]</div>
								<div>[ADDRESS.STREET]</div>
								<div>[ADDRESS.TOWN]</div>
								<div>[ADDRESS.POSTCODE]</div>
								<div>[PRICE]</div>
								<div>[SUMMARY]</div>
								<div>[DESCRIPTION]</div>
								<div>[BEDROOMS]</div>
								<div>[BATHROOMS]</div>
								<div>[RECEPTION_ROOMS]</div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-10">
								<div style="text-align: left;">
									<codemirror v-model="jsonFormatted" :options="cmOptions"></codemirror>
								</div>
							</div>
					  	</div>
					</div>

					<div class="mdc-layout-grid">
						<button class="mdc-button mdc-button--raised" v-on:click="save">Test and save</button>
					</div>
				</section>
		</div>
	</div>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import ProgressSteps      from '../components/ProgressSteps.vue';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';

export default {
	data: function() {
		return {
			stages: {
				EVENT:  1,
				ENDPOINT:  2,
				PAYLOAD:  3,
			},
			stage: 1,
			events: [
				{type: 'Property', name: 'Property added'},
				{type: 'Property', name: 'Property status changed'},
				{type: 'Property', name: 'Property sold'},
				{type: 'Applicant', name: 'Applicant added'},
				{type: 'Applicant', name: 'Applicant offer accepted'},
				{type: 'Applicant', name: 'Applicant matched to property'},
			],
			eventType: '',
			eventValue: '',
			cmOptions: {
				tabSize: 2,
				mode: 'application/json',
				theme: 'base16-dark',
				lineNumbers: true,
				line: true,
			},
			json: {
				branch: {
					branch_id: 123,
					channel: '[SERVICE_TYPE]',
					overseas: false
				},
				property: {
					agent_ref: '[PROPERTY_ID]',
					property_type: '[TYPE]',
					status: '[STATUS]',
					create_date: '[DATE]',
					address: {
						street: '[ADDRESS.STREET]',
						town: '[ADDRESS.TOWN]',
						postcode: '[ADDRESS.POSTCODE]'
					},
					price: '[PRICE]',
					summary: '[SUMMARY]',
					description: '[DESCRIPTION]',
					bedrooms: '[BEDROOMS]',
					bathrooms: '[BATHROOMS]',
					reception_rooms: '[RECEPTION_ROOMS]'
				}
			}
		}
	},
	mixins: [utils],
	components: {
		ProgressSteps,
		codemirror
	},
	mounted: async function() {
	},
	computed: {
		stagesArray() {
			return Object.values(this.stages);
		},
		eventTypes() {
			let types = [];
			this.events.map(event => {
				if(types.indexOf(event.type) === -1) {
					types.push(event.type);
				}
			});
			return types.sort();
		},
		eventsFromType() {
			return this.events.filter(event => event.type == this.eventType);
		},
		jsonFormatted() {
			return JSON.stringify(this.json, null, 4).replace('"[', '[').replace(']"', ']');
		}
	},
	methods: {
		save() {
			this.$router.push('/supplier');
		}
	},
}
</script>

<style>
.CodeMirror {
	height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Supplier-BA-Trigger.vue